"use client";

import type { ButtonHTMLAttributes, ReactNode } from "react";

type ResourceSwitcherItemProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "title"> & {
  selected: boolean;
  title: string;
  description?: ReactNode;
  initials?: string;
  thumb?: ReactNode;
  showThumb?: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export function ResourceSwitcherItem({
  selected,
  title,
  description,
  initials = title.slice(0, 2).toUpperCase(),
  thumb,
  showThumb = true,
  onClick,
  disabled = false,
  className = "",
  ...buttonProps
}: ResourceSwitcherItemProps) {
  return (
    <button
      {...buttonProps}
      type="button"
      role="menuitemradio"
      aria-checked={selected}
      className={`sidebar-link w-full text-left ${selected ? "sidebar-link-active" : ""} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {showThumb ? thumb ?? (
        <span
          aria-hidden="true"
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-xs font-semibold ${
            selected ? "bg-white/20 text-white" : "bg-bg-muted text-text-secondary"
          }`}
        >
          {initials}
        </span>
      ) : null}
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-semibold">{title}</span>
        {description ? (
          <span className={`mt-0.5 block truncate text-xs ${selected ? "text-white/80" : "text-text-muted"}`}>
            {description}
          </span>
        ) : null}
      </span>
      {selected ? (
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/20 text-white">
          <svg viewBox="0 0 24 24" aria-hidden="true" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="m5 12 4 4L19 6" />
          </svg>
        </span>
      ) : null}
    </button>
  );
}
